import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { FILE_STATE } from "../../../../../redux/constants/metaData";

export function WorkingDocumentDetailsDialogActions({
  isDetailsComplete,
  isCheckinMode = false,
  theme,
  onClose,
  onCheckIn,
  workingIfsDocument = {},
  getCheckinButtonText,
  disableCheckin = false,
}) {
  const closeButton = (
    <Button
      onClick={onClose}
      variant="outlined"
      sx={{
        color: theme.colors.themeDarkColor,
        borderColor: theme.colors.themeDarkColor,
        fontFamily: theme.fonts.regular,
        fontSize: `${theme.fontSizes?.normal ?? 12}px`,
        textTransform: "none",
        borderRadius: "20px",
        paddingX: 2,
      }}
    >
      Close
    </Button>
  );

  if (isDetailsComplete) {
    const fileState = workingIfsDocument?.FileState;
    const normalizedFileState = String(fileState ?? "")
      .trim()
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/\s+/g, " ");
    const isCheckedInDocument =
      fileState === FILE_STATE.checkedIn || normalizedFileState === "checked in";

    return (
      <DialogActions sx={{ padding: "15px", paddingTop: "6px" }}>
        {closeButton}
        {isCheckinMode && !isCheckedInDocument && (
          <Button
            disabled={disableCheckin}
            onClick={() => onCheckIn(workingIfsDocument)}
            sx={{
              backgroundColor: theme.colors.themeDarkColor,
              fontFamily: theme.fonts.regular,
              fontSize: `${theme.fontSizes?.normal ?? 12}px`,
              textTransform: "none",
              borderRadius: "20px",
              paddingX: 2,
              border: `1px solid ${theme.colors.themeDarkColor}`,
              color: theme.colors.deactiveFontColor,
              "&.Mui-disabled": {
                opacity: 1,
                backgroundColor: theme.colors.deactiveColor,
                color: theme.colors.deactiveFontColor,
                border: `1px solid ${theme.colors.deactiveColorLight}`,
              },
            }}
          >
            {getCheckinButtonText(workingIfsDocument?.FileState)}
          </Button>
        )}
      </DialogActions>
    );
  }

  return (
    <DialogActions sx={{ padding: "8px 12px 10px" }}>
      {closeButton}
    </DialogActions>
  );
}
